export const IOVATION_DELAY_IN_MS = 4000;
export const IOVATION_MAX_TIMEOUT_IN_MS = 60000;
